import React from "react"
import { Link } from "react-router-dom"
import logo from "./WaveSaleslandingpage/img/logo.png"

export default function TerminosCondiciones() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Header con logo */}
      <header className="bg-gray-900/50 backdrop-blur-sm border-b border-gray-700 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="WaveSales" className="h-10 w-auto" />
            <span className="text-xl font-bold text-white">WaveSales</span>
          </Link>
          <Link 
            to="/" 
            className="text-gray-300 hover:text-white transition-colors text-sm"
          >
            ← Volver al inicio
          </Link>
        </div>
      </header>

      {/* Contenido principal */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white/5 backdrop-blur-md rounded-2xl border border-gray-700/50 shadow-2xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-white mb-2">
            Términos y Condiciones de Uso
          </h1>
          <p className="text-gray-400 text-sm mb-8">
            Vigencia: 18/11/2025
          </p>

          <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
            <p className="text-gray-300 leading-relaxed">
              Estos Términos y Condiciones (en adelante "Términos") rigen el acceso y uso de los servicios ofrecidos por <strong className="text-white">WaveSales</strong> a través de{" "}
              <a href="https://wave-sales.com" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                https://wave-sales.com
              </a>{" "}
              y cualquier subdominio o servicio relacionado (en adelante "la Plataforma"). Al registrarte o usar la Plataforma aceptas estos Términos.
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">1. Partes</h2>
              <p className="text-gray-300 leading-relaxed">Contratan:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li><strong className="text-white">WaveSales</strong> — proveedor de la Plataforma.</li>
                <li>"Cliente" o "Usuario": persona natural o jurídica que contrata el servicio.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">2. Objeto</h2>
              <p className="text-gray-300 leading-relaxed">
                WaveSales brinda una plataforma para gestionar integraciones con terceros (por ejemplo, Meta/WhatsApp), administración de plantillas, envíos y analítica, además de funciones administrativas y de facturación según plan contratado.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">3. Registro y cuenta</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>El usuario debe proporcionar datos veraces.</li>
                <li>El usuario es responsable de mantener la confidencialidad de sus credenciales y de todas las actividades bajo su cuenta.</li>
                <li>WaveSales puede suspender o eliminar cuentas por incumplimiento.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">4. Servicios y facturación</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>WaveSales ofrece planes de suscripción (semanal/mensual/anual) y funcionalidades sujetas a cada plan.</li>
                <li>Los pagos de suscripción se gestionan mediante el proveedor de pago elegido (Stripe/PayPal u otro).</li>
                <li>Los cargos asociados con el uso de APIs de terceros (por ejemplo: costos de mensajes en WhatsApp Business) son cobrados por Meta a la cuenta que el cliente tenga habilitada en Meta (a menos que exista un acuerdo expreso que indique lo contrario).</li>
                <li>Los precios publicados pueden cambiar; notificaremos cambios con 30 días de anticipación salvo actualización tarifaria urgente por terceros.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">5. Obligaciones del Cliente</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Mantener permisos y autorizaciones válidas en servicios externos (ej. Meta Business Manager, métodos de pago).</li>
                <li>Asegurar que el uso de la API y envíos cumpla leyes y políticas (consentimiento de destinatarios, regulaciones locales).</li>
                <li>No usar la plataforma para actividades ilícitas, SPAM o violación de derechos de terceros.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">6. Propiedad intelectual</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>WaveSales conserva todos los derechos sobre la Plataforma, software, marcas y documentación.</li>
                <li>El Cliente conserva la titularidad de sus datos y plantillas; concede a WaveSales una licencia limitada para operar el servicio.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">7. Niveles de servicio y soporte</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>WaveSales hará esfuerzos razonables para mantener la disponibilidad, pero no garantiza servicio ininterrumpido.</li>
                <li>
                  Soporte técnico:{" "}
                  <a href="mailto:soporte@wave-sales.com" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                    soporte@wave-sales.com
                  </a>{" "}
                  y horas de atención detalladas en la web.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">8. Confidencialidad</h2>
              <p className="text-gray-300 leading-relaxed">
                Ambas partes se comprometen a proteger información confidencial recibida durante la relación contractual.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">9. Limitación de responsabilidad</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>WaveSales no será responsable por daños indirectos, lucro cesante o pérdida de datos salvo dolo o negligencia grave.</li>
                <li>En todo caso, la responsabilidad máxima de WaveSales por daños directos estarán limitados al monto pagado por el Cliente en los últimos 12 meses por el servicio afectado.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">10. Duración y terminación</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>El servicio se presta por el período contratado y se renueva según el plan.</li>
                <li>WaveSales puede terminar el servicio por incumplimiento.</li>
                <li>El Cliente puede cancelar siguiendo el procedimiento y condiciones descritas en la Plataforma.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">11. Protección de datos</h2>
              <p className="text-gray-300 leading-relaxed">
                El tratamiento de datos se regirá por la{" "}
                <Link to="/politica-de-privacidad" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                  Política de Privacidad
                </Link>{" "}
                disponible en{" "}
                <a href="https://wave-sales.com/politica-de-privacidad" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                  https://wave-sales.com/politica-de-privacidad
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">12. Legislación aplicable</h2>
              <p className="text-gray-300 leading-relaxed">
                Estos Términos se rigen por la legislación del Ecuador. Cualquier disputa se someterá a los tribunales competentes de dicha jurisdicción.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">13. Contacto</h2>
              <p className="text-gray-300 leading-relaxed">
                Para notificaciones y consultas:{" "}
                <a href="mailto:soporte@wave-sales.com" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                  soporte@wave-sales.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer simple */}
      <footer className="bg-gray-900/50 border-t border-gray-700 py-8 mt-12">
        <div className="max-w-6xl mx-auto px-6 text-center text-gray-400 text-sm">
          <p>© 2025 WaveSales. Todos los derechos reservados.</p>
          <div className="mt-4 flex items-center justify-center gap-6">
            <Link to="/terminos-y-condiciones" className="hover:text-white transition-colors">
              Términos y condiciones
            </Link>
            <Link to="/politica-de-privacidad" className="hover:text-white transition-colors">
              Política de privacidad
            </Link>
            <Link to="/politica-de-cookies" className="hover:text-white transition-colors">
              Política de Cookies
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
